import React from "react";
import ReactHtmlTableToExcel from "react-html-table-to-excel";
import styled from "styled-components";
import GunNft from "../../Images/gunnft.png";

const Root = styled.div`

`;
const Container = styled.table`
width: 100%;
`;
const NftHeadingContainer = styled.tr`
  display: grid;
  grid-template-columns: 14% 14.5% 14% 14% 14% 14% 14%;
  align-items: center;
  text-align: start;
  border-radius: 10px;
  color: #fff;
  font-weight: 500;
  font-size: 24px;
  line-height: 140%;
  margin: 40px;
`;

const NftDetailsWrapper = styled.div`
  color: #fff;
  display: grid;
  margin-top: 20px;
  grid-template-columns: 14% 14.5% 14% 14% 14% 14% 14%;
  -webkit-box-align: center;
  align-items: center;
  text-align: start;
  /* padding: 0px 15px; */
  box-shadow: 0px 0px 5px 5px #0000;
  border-radius: 5px;
  margin: 20px 40px 40px 40px;
`;

const HeadingText = styled.th`
display: flex;
justify-content:flex-start;
align-items:start;
text-align:start;
`;
const NftDetails = styled.td`
display: flex;
justify-content:flex-start;
text-align:start;
align-items:center;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 20px;
`;

const NftImageWrapper = styled.div``;
const NftDetailsimg = styled.img``;

const NftTable = () => {
  return (
    <Root>
   
      <Container id="table-to-xls">
        <NftHeadingContainer>
          <HeadingText>Name</HeadingText>
          {/* <HeadingText>Image</HeadingText> */}
          <HeadingText>Total Minted</HeadingText>
          <HeadingText>Base Price</HeadingText>
          <HeadingText>Hash Value</HeadingText>
          <HeadingText>Sold Out</HeadingText>
          <HeadingText>Inventory</HeadingText>
          <HeadingText>Damage (%)</HeadingText>
        </NftHeadingContainer>

        <NftHeadingContainer>
          <NftDetails>Alien Gun</NftDetails>
          {/* <NftImageWrapper>
            <NftDetailsimg src={GunNft}></NftDetailsimg>
          </NftImageWrapper> */}
          <NftDetails>100</NftDetails>
          <NftDetails>$190</NftDetails>
          <NftDetails>30</NftDetails>
          <NftDetails>60</NftDetails>
          <NftDetails>40</NftDetails>
          <NftDetails>25%</NftDetails>
        </NftHeadingContainer>
      </Container>
    </Root>
  );
};

export default NftTable;
